import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'

import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  GenerateProposalDocumentsClientRequest,
  GenerateProposalDocumentsClientResponse,
} from '../../../@types/GenerateProposalDocuments'
import { api } from '../../../Services/API'
import { useGenerateProposalDocumentsStore } from '../../../Stores/useGenerateProposalDocumentsStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: GenerateProposalDocumentsClientRequest) => {
  const response = await api.post<GenerateProposalDocumentsClientResponse>(
    API_ROUTES.generateProposalDocuments,
    payload,
  )

  return response.data
}

export const useGenerateProposalDocuments = () => {
  const { setGenerateProposalDocuments, setIsGenerateProposalDocuments } =
    useGenerateProposalDocumentsStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: GenerateProposalDocumentsClientRequest) =>
      request(payload!),
    onSuccess(data) {
      setGenerateProposalDocuments(data)
      setIsGenerateProposalDocuments(true)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
